import { useReportRange } from "../lib/report-range.js";
import { useUrlFilters } from "../lib/url-filters.js";
import { DateRangePill } from "./date-range-pill.js";
import { EnginePill } from "./engine-pill.js";

/**
 * The date range and engine for a report view, under the page's title.
 *
 * Both live in the address, so the pills and the screen reading them agree by
 * construction: the screen reads the same `useReportRange`. The pills only —
 * each screen keeps its own row around them, as it had before the top bar
 * briefly carried them (Abhishek preferred them by the title).
 */
export function ReportFilters({ today }: { readonly today: Date }) {
  const { setParam } = useUrlFilters();
  const range = useReportRange(today);
  return (
    <>
      <DateRangePill
        from={range.from}
        to={range.to}
        today={range.today}
        onChange={(next) => {
          setParam("from", next.from);
          setParam("to", next.to);
        }}
      />
      <EnginePill
        engine={range.engine}
        onChange={(next) => {
          setParam("engine", next ?? "");
        }}
      />
    </>
  );
}
